import { AnswerCallbackRequest, AnswerStatementRequest } from '../types/formdataTypes';
import { CallbackRequest, CallbackResponse } from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'Callback';

export const getCallback = async (id: string, token: string): Promise<HttpResponse<CallbackResponse>> => {
	const result = await makeRequest<string, CallbackResponse>(`${endpoint}?callbackId=${id}&token=${token}`, null, 'get');
	return result;
};

export const createCallback = async (request: CallbackRequest): Promise<HttpResponse<string>> => {
	const result = await makeRequest<CallbackRequest, string>(`${endpoint}`, request, 'post');
	return result;
};

export const answerCallback = async (request: AnswerCallbackRequest): Promise<HttpResponse<string>> => {
	const formData = new FormData();
	formData.append('callbackId', request.callbackId);
	formData.append('emailToken', request.emailToken);
	formData.append('answer', request.answer);

	if (request.files) {
		request.files.forEach((file, index) => {
			formData.append(`files[${index}]`, file.bytes, file.fileName);
		});
	}

	if (request.links) {
		formData.append('links', JSON.stringify(request.links));
	}

	const result = await makeRequest<any, string>(`${endpoint}/answer`, formData, 'post', true);
	return result;
};
